import { DefaultLayout, DefaultLayoutProps } from '@/app/layouts/DefaultLayout.tsx'
import { cn } from '@lair-finance/util'

export function RestakeLayout({ contentClassName, ...props }: DefaultLayoutProps) {
  return (
    <div
      className={cn(
        'bg-[url(/static/images/restake/background-m.png)] bg-no-repeat bg-[length:375px_167px] bg-[center_70px]',
        'sm:bg-[url(/static/images/restake/background.png)] sm:bg-[length:1200px_auto] sm:bg-[center_106px]',
      )}
    >
      <DefaultLayout contentClassName={cn('max-w-[762px] !pt-0', contentClassName)} {...props} />
    </div>
  )
}
